import { Loader2, Eye, Download } from 'lucide-react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Badge } from '@/components/ui/badge'
import { useUserWorkbookActions } from '@/services/admin/users.service'

interface UserWorkbookActivityProps {
  userId: string
}

export function UserWorkbookActivity({ userId }: UserWorkbookActivityProps) {
  const { data: actions, isLoading } = useUserWorkbookActions(userId)

  const formatDate = (dateString: string) =>
    new Date(dateString).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    )
  }

  if (!actions || actions.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        <p>📄 Nenhuma interação com workbooks</p>
      </div>
    )
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Aula</TableHead>
          <TableHead>Módulo</TableHead>
          <TableHead>Ação</TableHead>
          <TableHead>Data</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {actions.map((action) => (
          <TableRow key={action.id}>
            <TableCell className="font-medium">{action.episodeTitle}</TableCell>
            <TableCell className="text-muted-foreground">{action.moduleTitle}</TableCell>
            <TableCell>
              {action.action === 'view' ? (
                <Badge variant="secondary" className="gap-1">
                  <Eye className="h-3 w-3" />
                  Visualizou
                </Badge>
              ) : (
                <Badge variant="default" className="gap-1">
                  <Download className="h-3 w-3" />
                  Download
                </Badge>
              )}
            </TableCell>
            <TableCell className="text-sm">{formatDate(action.createdAt)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
